<template>
   <Loading :isLoading="caseLoading">
  <v-layout
    row wrap fluid class="homepage-card-container"
    id="case-history" >
      <CaseCard v-for="(c, caseIndex) in items" :key="caseIndex" :case-data="c"></CaseCard>
  </v-layout>
  </Loading>
</template>

<script>
import { mapState } from 'vuex'
import Loading from "@/components/shared/Loading.vue"
import CaseCard from "@/components/CaseCard.vue"

export default {
  name: "CaseHistory",
  components: { Loading, CaseCard },
  data: () => ({ userLoading: false }),
  computed: {
    ...mapState({
      caseLoading: state => state.homepage.recentCasesLoading,
      items: state => state.homepage.recent_cases
    })
  }
}
</script>
